module.exports = __webpack_public_path__ + "img/loading.ecd18277.gif";